import { render } from "./IconH2HStatistics.vue?vue&type=template&id=67224c93&ts=true"
import script from "./IconH2HStatistics.vue?vue&type=script&lang=ts"
export * from "./IconH2HStatistics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__